import React from 'react'
import ReactDOM from 'react-dom'
// import 'antd-mobile/dist/antd-mobile.css'
import App from './App'
// import { createStore } from 'redux'
import { Provider } from 'react-redux'
// import rootReducer from './redux/reducers'
import registerServiceWorker from './registerServiceWorker'

import store from '@/redux'

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>
  , document.getElementById('root')
)
registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js